import * as textControls from '#packages/textControls';
import * as stateManagement from '#packages/stateManagement';

import type { LinksHelperType } from '#packages/textControls';
import type { LinksManagerType } from '@wix/wix-richtext';
import type { ThunkAction } from 'types/redux';
import type { MapDispatchToPropsFunction } from '@wix/santa-editor-utils';
import type { DispatchMapperArgs } from '@wix/editor-elements-types/editor';

const textEditorActions = stateManagement.text.actions;

const mapStateToProps = ({ editorAPI }: DispatchMapperArgs) => {
  const comps = editorAPI.selection.getSelectedComponents();

  return {
    comps,
    layout:
      comps.length && editorAPI.components.layout.getRelativeToScreen(comps),
    documentServices: editorAPI.documentServices,
  };
};

const getFonts: () => ThunkAction =
  (...args) =>
  (dispatch, getState, { editorAPI }) =>
    textControls.fontUtils.getCurrentSelectableFontsWithParams(
      editorAPI,
      false,
      true,
      ...args,
    );
const loadTextEditingAPI: (manager: AnyFixMe) => ThunkAction =
  (manager) =>
  (dispatch, getState, { editorAPI }) =>
    editorAPI.store.dispatch(
      textEditorActions.invisibleTextEditor.load(manager),
    );
const unloadTextEditingAPI: () => ThunkAction =
  () =>
  (dispatch, getState, { editorAPI }) =>
    editorAPI.store.dispatch(textEditorActions.invisibleTextEditor.unload());

const loadLinksHelper: (linksHelper: LinksHelperType) => ThunkAction =
  (linksHelper) =>
  (dispatch, getState, { editorAPI }) =>
    editorAPI.store.dispatch(
      textEditorActions.invisibleTextEditor.loadLinksHelper(linksHelper),
    );
const unloadLinksHelper: () => ThunkAction =
  () =>
  (dispatch, getState, { editorAPI }) =>
    editorAPI.store.dispatch(
      textEditorActions.invisibleTextEditor.unloadLinksHelper(),
    );

export interface InvisibleTextEditorDispatchProps {
  getFonts: (args: any[]) => void;
  loadTextEditingAPI: (manager: LinksManagerType) => void;
  unloadTextEditingAPI: () => void;
  loadLinksHelper: (linksHelper: LinksHelperType) => void;
  unloadLinksHelper: () => void;
}

export interface InvisibleTextEditorOwnProps {}

const mapDispatchToProps: MapDispatchToPropsFunction<
  InvisibleTextEditorDispatchProps,
  InvisibleTextEditorOwnProps
> = (dispatch) => ({
  getFonts(...args: Parameters<typeof getFonts>) {
    return dispatch(getFonts(...args));
  },
  loadTextEditingAPI(manager: LinksManagerType) {
    return dispatch(loadTextEditingAPI(manager));
  },
  unloadTextEditingAPI() {
    return dispatch(unloadTextEditingAPI());
  },
  loadLinksHelper(linksHelper: LinksHelperType) {
    return dispatch(loadLinksHelper(linksHelper));
  },
  unloadLinksHelper() {
    return dispatch(unloadLinksHelper());
  },
});

export { mapStateToProps, mapDispatchToProps };
